// extracted by mini-css-extract-plugin
module.exports = {"container":"compliance_container__bMlRc","list":"compliance_list__NmR_C","heading":"compliance_heading__bAcNG"};